import { BEFORE_USER, SET_USER, SET_CREATORS, TOP_SELLERS, SET_INDIVIDUAL_USER, GET_USER, SET_BANNER, GET_INVESTORS, GET_INVESTOR } from '../../redux/types';

const initialState = {
    userData: null,
    userAuth: false,
    creatorsAuth: false,
    topSellersAuth: false,
    individualUserAuth: false,
    individualUser: null,
    bannerAuth: false,
    banner: null,
    getInvestors: null,
    investorsAuth: false,
    getInvestor: null,
    investorAuth: false
}

export default function userRed(state = initialState, action) {
    switch (action.type) {
        case GET_INVESTORS:
            return {
                ...state,
                getInvestors: action.payload,
                investorsAuth: true
            }
        case GET_INVESTOR:
            return {
                ...state,
                getInvestor: action.payload,
                investorAuth: true
            }
        case SET_USER:
            return {
                ...state,
                userData: action.payload,
                userAuth: true
            }
        case GET_USER:
            return {
                ...state
            }
        case SET_BANNER:
            return {
                ...state,
                bannerAuth: true,
                banner: action.payload
            }
        case SET_CREATORS:
            return {
                ...state,
                creators: action.payload,
                creatorsAuth: true
            }
        case TOP_SELLERS:
            return {
                ...state,
                sellers: action.payload,
                topSellersAuth: true
            }
        case SET_INDIVIDUAL_USER:
            return {
                ...state,
                individualUser: action.payload,
                individualUserAuth: true
            }
        case BEFORE_USER:
            return {
                ...state,
                userData: null,
                userAuth: false,
                creatorsAuth: false,
                topSellersAuth: false,
                individualUserAuth: false,
                individualUser: null,
                bannerAuth: false,
                banner: null,
                getInvestors: null,
                investorsAuth: false,
                getInvestor: null,
                investorAuth: false
            }
        default:
            return {
                ...state
            }
    }
}